import React from 'react'
import Hero from '../components/home/Hero'
import AboutMe from '../components/home/AboutMe'
import Projects from '../components/home/Projects'
import Contact from '../components/home/Contact'
import Testimonials from '../components/home/Testimonials'
import Faq from '../components/global/Faq'

const Home = () => {
  const homeFaqs = [
    {
        id: 1,
        question: "Who is Gulfam Haider",
        answer: "I am an 'industry-experienced web developer' to my clients, a 'supportive senior' to many, and a 'programming genius' to most. I handle both frontend and backend development, as well as database management. Additionally, I serve as a programming mentor, helping, training, and guiding people in programming. Learn about me more in the AboutMe Page.",
    },
    {
        id: 2,
        question: "How can we trust you to avoid fraudulent activities or scams in our collaboration?",
        answer: "I will keep you updated on our project, and we'll agree on everything upfront, so there are no surprises. There are also lots of other ways to avoid fraud from both parties like going for milestones technique where payment is done by achieving discussed milestones, or we can shift our whole conversation to freelancing websites where payment is secured for both client and developer's end. You can trust that I'll always act in your best interest, ensuring a fair and successful collaboration.",
    },
    {
        id: 3,
        question: "What services do you offer as a web developer?",
        answer: "I offer a wide range of web-related solutions, from creating personal websites to developing web applications, e-commerce platforms, dynamic-dashboards, web sockets, Shopify stores, business websites, and custom web designs too. These websites can include frontend, backend, and database functionalities tailored to your specific requirements.",
    },
    {
        id: 4,
        question: "What programming languages and technologies do you work with?",
        answer: `For frontend, I am proficient in HTML, CSS (including Tailwind CSS, SASS and Bootstrap), JavaScript, TypeScript, React.js, and Next.js. For backend development, I specialize in NodeJs, Express, RESTAPI, MongoDB, SupaBase and MySQL.`,
    },
    {
        id: 5,
        question: "What types of websites have you worked on in the past?",
        answer: "In the past, I've had the opportunity to work on various types of websites, including personal branding websites, business websites, e-commerce stores, personal portfolio websites, real-time messaging apps, and more.",
    },
    {
        id: 6,
        question: "How do you handle revisions or changes to the project scope?",
        answer: "When there are changes or revisions needed for the project, I believe in talking openly with my clients. If they want something different, they just let me know. Then, I figure out how those changes might affect the time or cost of the project. If we need to adjust anything, we talk about it together. My aim is to make sure the final result matches what my clients want, and I keep them informed every step of the way. Plus, I always offer unlimited revisions to my clients until they are satisfied.",
    },
    {
        id: 7,
        question: "Can you share some of the projects you've worked on in the tech industry?",
        answer: "There are different pricing plans (Free, Basic, Starter, Pro) available on Animaker. Check out the pricing page to know more about each plan.",
    },
    {
        id: 8,
        question: "What is your approach to handling multiple freelance projects simultaneously?",
        answer: `As I have mentioned earlier, I have a team of experienced developers. When I have a heavy workload, I rely on their help to meet deadlines and maintain the quality of the product.`,
    },
];


return (
      
        <>
          <Hero />
          <AboutMe />
          <Projects />
          <Testimonials />
          <Faq faqsData={homeFaqs} />
          <Contact />
        </>
      
  );
};

export default Home;